module.exports = __webpack_public_path__ + "img/member-bg-m.1933ed7.jpg";